import { render, staticRenderFns } from "./BillingDocumentsForm.vue?vue&type=template&id=38d0c51c&scoped=true"
import script from "./BillingDocumentsForm.vue?vue&type=script&lang=js"
export * from "./BillingDocumentsForm.vue?vue&type=script&lang=js"
import style0 from "./BillingDocumentsForm.vue?vue&type=style&index=0&id=38d0c51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0c51c",
  null
  
)

export default component.exports